// scroll-up icon
document.addEventListener('DOMContentLoaded', (event) => {
    const scrollTopBtn = document.getElementById('scroll-to-top');

    window.addEventListener('scroll', () => {
        if (window.scrollY > window.innerHeight) { // 100% from the top
            scrollTopBtn.classList.remove('hidden');
            scrollTopBtn.classList.add('fade-in');
        } else {
            scrollTopBtn.classList.add('hidden');
            scrollTopBtn.classList.remove('fade-in');
        }
    });

    scrollTopBtn.addEventListener('click', (e) => {
        e.preventDefault();
        smoothScrollUp(0, 600); // Scroll to the top of the document
    });
});

function smoothScrollUp(targetPosition, duration) {
    const startPosition = window.pageYOffset;
    let startTime = null;

    function animation(currentTime) {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const run = ease(timeElapsed, startPosition, targetPosition - startPosition, duration);
        window.scrollTo(0, run);
        if (timeElapsed < duration) requestAnimationFrame(animation);
    }

    function ease(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
    }

    requestAnimationFrame(animation);
}
